import { render, staticRenderFns } from "./VersionDescription.vue?vue&type=template&id=f1e53462&scoped=true&"
import script from "./VersionDescription.vue?vue&type=script&lang=js&"
export * from "./VersionDescription.vue?vue&type=script&lang=js&"
import style0 from "./VersionDescription.vue?vue&type=style&index=0&id=f1e53462&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e53462",
  null
  
)

export default component.exports